import { DOCUMENT_ELEMENT } from '@/scripts/constants';

function makeRequest(method, url, done) {
  const xhr = new XMLHttpRequest();
  xhr.open(method, url);
  xhr.onload = () => {
    done(null, xhr.response);
  };
  xhr.onerror = () => {
    done(xhr.response);
  };
  xhr.send();
}

export default function showWeather(element) {
  // And we'd call it as such:
  if (!element) return;

  const { lat, lon } = element.dataset;
  const { lang } = DOCUMENT_ELEMENT;
  makeRequest('GET', `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lon}&APPID=8709754e1c1998749648a7469c5d79dd&units=metric&lang=${lang}`, (err, response) => {
    if (err) { throw err; }
    const data = JSON.parse(response);
    $(element).html(`
      <div class="info-item__top">
        <span class="temp info-item__main">${Math.round(data.main.temp)}</span>
      </div>
      <div class="info-item__bot">
        <p>${data.weather[0].description}</p>
      </div>
      
     `);
  });
}



// WEBPACK FOOTER //
// ./scripts/elements/weather.js